<template web>
  <div class="page-account-view page-news-view">
    <header-back :url="'/consorcios/'+owners_association.id+'/votaciones'" />

    <section class="bar theme-blue">
      <div class="container" v-if="no_votation">
        <div class="bar-avatar">
          <span><img src="@/assets/img/icono_votacion.svg" class="img_min"></span>
        </div>
        <h3 class="bar-firm-name">{{votation.title}}</h3>
        <br>
      </div>
      <div class="container" v-else>
        <div class="bar-avatar">
          <span><img src="@/assets/img/icono_votacion.svg" class="img_min"></span>
        </div>
        <h3 class="bar-firm-name">Votacion</h3>
        <h5 class="bar-tagline">No disponible en este momento, intente nuevamente mas tarde.</h5>
        <br>
      </div>
    </section>

    <div class="container bar-news">
      <vue-element-loading :active="isLoading" spinner="spinner" color="#CE4169" />
      <vue-element-loading :active="isLocalLoading" spinner="spinner" color="#CE4169" />

      <div v-if="no_votation">

        <div class="news-detail shadow  mt-4">
          <h4 class="mt-2"><strong>{{votation.title}}</strong></h4>
          <p class="news-body" v-html="votation.description" />
          <p class="news-body " >Inicia: {{ votation.starts_at | moment('ll') }} - Finaliza: {{ votation.ends_at | moment('ll') }}</p>
          <div class="status-badge-votations mb-4" :class="'badge-' + getVotationStatus(votation.VotationStatuses.title)">
            {{ votation.VotationStatuses.title }}
          </div>
          <div class="text-center news-image mb-2">
            <div v-for="image in votation.images" :key="image.id">
              <a :href="image.url" v-if="!is_capacitor" data-lightbox="roadtrip" class="d-block mb-4 h-100">
                <img class="img-fluid img-thumbnail" :src="image.thumbnail_xs" alt="">
              </a>
              <a class="d-block mb-4 h-100" data-lightbox="roadtrip" v-if="is_capacitor" >
                <img :src="image.url" class="img-fluid img-thumbnail" alt="" @click="downloadFallback(image, 'img')">
              </a>
            </div>
          </div>
        </div>

        <div class="news-detail shadow mt-4 pb-2 " v-if="votation.votation_files && votation.votation_files.length > 0">
          <div class="mt-2 mb-2">
            <h5 class="ml-1">Adjuntos</h5>
            <div class="mt-3">
              <div class="news-attachments" v-for="attachment in votation.votation_files" :key="attachment.id">
                <a :href="attachment.file_url" target="_blank"
                   class="btn btn-white" v-if="!is_capacitor" style="color: #CE4169; margin: 0; padding: 0">
                  <img src="@/assets/img/icons/document-alt.svg" class="icon" style="vertical-align: top;"
                       alt="" />
                  {{ attachment.file_name.length > 40 ? attachment.file_name.substring(0, 40) + '...' : attachment.file_name }}
                </a>
                <a @click="downloadFallback(attachment.file_url)" target="_blank"
                   class="btn btn-white" v-else style="color: #CE4169; margin: 0; padding: 0">
                  <img src="@/assets/img/icons/document-alt.svg" class="icon" style="vertical-align: top;"
                       alt="" /> {{attachment.file_name}}
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="news-detail shadow  pb-2 mt-4 " v-if="votation.votation_comments &&  votation.votation_comments.length>0">
          <div>
            <h4 ><strong>Comentarios</strong></h4>
            <div class="mt-3">
              <div class="news-attachments" v-for="votation_comment in votation.votation_comments" :key="votation_comment.id">
                            <p class="mb-1" v-html="votation_comment.text" />
              </div>
            </div>
          </div>
        </div>

        <div class="news-detail shadow mt-4 pb-2 ">
          <h4 v-if="hasVoted" class="mt-2"><strong>Tu voto</strong></h4>
          <h4 v-else-if="votation.VotationStatuses.id === 1">
            <strong>Selecciona {{ votation.votes_per_functional_unit === 1 ? 'una opción' : 'hasta '+votation.votes_per_functional_unit + ' opciones' }}
          </strong></h4>
          <h4 v-else class="mt-4"><strong>Opciones de la votación</strong></h4>

          <div
              v-for="(option, index) in votation.votation_options"
              :key="option.id"
              class="option-item"
              :class="{
                'selected-option': hasVoted && votation.votation_votes[0].voted_for.includes(index),
                'not-selected-option': hasVoted && !votation.votation_votes[0].voted_for.includes(index)
              }">
            <label class="option-label">
              <input v-if="!hasVoted && votation.votes_per_functional_unit === 1"
                     type="radio" name="voteOption" :value="option.id" v-model="selectedOption"
                     :disabled="hasVoted || votation.VotationStatuses.id !== 1" />
              <input v-if="!hasVoted && votation.votes_per_functional_unit > 1"
                     type="checkbox" :value="option.id" v-model="selectedOptions"
                     :disabled="hasVoted || votation.VotationStatuses.id !== 1 || (selectedOptions.length >= votation.votes_per_functional_unit && !selectedOptions.includes(option.id))" />
              <span>{{ index + 1 }}. {{ option.text }}</span>
            </label>
            <a v-if="is_capacitor && option.file_url" @click="downloadFallback(option.file_url)" class='btn btn-rounded btn-outline-primary value'>ADJUNTO</a>
            <a v-else-if="!is_capacitor && option.file_url" :href="option.file_url" target="_blank" class="btn btn-rounded btn-outline-primary value">ADJUNTO</a>
          </div>

          <div v-if="!hasVoted && votation.VotationStatuses.id === 1" class="text-center mt-3 mb-2">
            <button class="btn btn-primary" :disabled="!canVote || isVoting" @click="submitVote">
              Votar
            </button>
          </div>

          <div v-if="!hasVoted && votation.VotationStatuses.id !== 1" class="no-vote-notice mb-2">
            No has emitido tu voto en esta votación.
          </div>
        </div>

        <div v-if="votation.VotationStatuses.id === 3" class="results-container news-detail shadow mt-4 pb-2  pb-2">
          <h4 class=" mt-2"><strong>Resultados</strong></h4>
          <div v-for="option in sortedResults" :key="option.id" class="result-item"
               :class="{ 'is-winner': option.position === winningOptionIndex, 'is-loser': option.position !== winningOptionIndex }">
            <div class="result-label">
              <span class="option-text">{{ option.text }}</span>
              <span class="vote-count">Votos: {{ votation.results[option.position] }} ({{ getPercentage(option.position).toFixed(1) }}%)</span>
            </div>
            <div class="progress-bar-container">
              <div class="progress-bar-fill"
                   :style="{ width: getPercentage(option.position) + '%', backgroundColor: barColors[option.position % barColors.length] }">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="news-detail shadow" v-else>
        <div class="empty-state empty-state-documents" id="no-documents-message" v-if="imgNo">
          <div class="wrapper">
            <h4>¡La votación no se encuentra disponible en este momento!</h4>
            <p>Vuelve a intentar nuevamente mas tarde, o contacta a tu administración para mas información.</p>
            <img src="@/assets/img/empty-states/mensaje-documento-eliminado.png" class="image-empty" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Capacitor } from '@capacitor/core';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { Dialog } from '@capacitor/dialog';
import axios from 'axios';
import HeaderBack from '@/components/Layouts/HeaderBack';

export default {
  components: {
    HeaderBack,
  },
  name: 'VotationDetail',
  props: ['owners_association', 'no_votation', 'votation', 'isLoading', 'imgNo'],
  data() {
    return {
      pdf: null,
      title: null,
      localuri: null,
      isLocalLoading: false,
      selectedOption: null,
      selectedOptions: [],
      barColors: [
        '#42A5F5', '#66BB6A', '#FFA726', '#EF5350', '#AB47BC',
        '#26A69A', '#FFCA28', '#78909C', '#5C6BC0', '#8D6E63',
      ],
      isVoting: false,
    };
  },
  computed: {
    totalVotes() {
      if (!this.votation.results) return 0;
      return Object.values(this.votation.results).reduce((sum, current) => sum + current, 0);
    },
    winningOptionIndex() {
      if (!this.votation.results || this.totalVotes === 0) return -1;
      let maxVotes = -1;
      let winningKey = -1;
      // eslint-disable-next-line no-restricted-syntax
      for (const key in this.votation.results) {
        if (this.votation.results[key] > maxVotes) {
          maxVotes = this.votation.results[key];
          winningKey = key;
        }
      }
      return parseInt(winningKey, 10);
    },
    // CAMBIO: Nueva propiedad computada para ordenar los resultados
    sortedResults() {
      if (!this.votation || !this.votation.votation_options || !this.votation.results) {
        return [];
      }
      // Creamos una copia para no mutar el prop original y la ordenamos
      return [...this.votation.votation_options].sort((a, b) => {
        const votesA = this.votation.results[a.position] || 0;
        const votesB = this.votation.results[b.position] || 0;
        return votesB - votesA; // Orden descendente
      });
    },
    is_capacitor() {
      if ((Capacitor.getPlatform() === 'ios') || (Capacitor.getPlatform() === 'android')) {
        return true;
      }
      return false;
    },
    hasVoted() {
      return this.votation.votation_votes && this.votation.votation_votes.length > 0;
    },
    canVote() {
      if (this.hasVoted || this.votation.votation_status_id !== 1) return false;
      const limit = this.votation.votes_per_functional_unit;
      if (limit === 1) {
        return this.selectedOption !== null;
      }
      return this.selectedOptions.length > 0 && this.selectedOptions.length <= limit;
    },
  },
  methods: {
    getPercentage(optionIndex) {
      if (this.totalVotes === 0) return 0;
      const votes = this.votation.results[optionIndex] || 0;
      return (votes / this.totalVotes) * 100;
    },
    getVotationStatus(votation_status) {

      switch (votation_status) {

        case 'Activa':
          return 'success';
        case 'Pendiente':
        case 'Borrador':
          return 'warning';
        case 'Finalizada':
          return 'info';
        case 'Cancelada':
          return 'error';
        case 'Pausada':
          return 'secondary';
        default:
          return 'secondary';
      }

    },  
    async submitVote() {
      this.isVoting = true;
      try {
        let votePayload;
        if (this.votation.votes_per_functional_unit === 1) {
          const selectedIndex = this.votation.votation_options.findIndex(opt => opt.id === this.selectedOption);
          votePayload = [selectedIndex];
        } else {
          const selectedIndexes = this.selectedOptions.map(selectedId => this.votation.votation_options.findIndex(opt => opt.id === selectedId));
          votePayload = selectedIndexes;
        }

        const data = {
          votation_id: this.votation.id,
          voted_for: votePayload,
        };

        await this.sendVote(this.owners_association.id, data);

        await this.$swal({
          icon: 'success',
          title: '¡Voto Registrado!',
          text: 'Tu voto ha sido emitido correctamente.',
          confirmButtonText: 'Entendido',
        });

        window.location.reload();

      } catch (error) {
        console.error('Error al enviar el voto:', error);
        this.$swal({
          icon: 'error',
          title: 'Error al Votar',
          text: 'No se pudo registrar tu voto. Por favor, intenta de nuevo.',
          confirmButtonText: 'Cerrar',
        });
      } finally {
        this.isVoting = false;
      }
    },
    async writeAndPreviewPdf(base64Data, fileName) {
      await Filesystem.mkdir({ path: 'joinup', directory: Directory.Cache }).then(async () => {
        await Filesystem.writeFile({
          path: `joinup/${fileName.replace(' ', '-')}`,
          data: Buffer.from(base64Data).toString('base64'),
          directory: Directory.Cache,
        }).then(async (writedFile) => {
          this.localuri = writedFile.uri;
          console.log(`local uri  ${writedFile.uri}`);
        });
      }).catch(async () => {
        await Filesystem.writeFile({
          path: `joinup/${fileName.replace(' ', '-')}`,
          data: Buffer.from(base64Data).toString('base64'),
          directory: Directory.Cache,
        }).then(async (writedFile) => {
          this.localuri = writedFile.uri;
          console.log(`local uri  ${writedFile.uri}`);
        });
      });
    },
    async hasFilePermisions() {
      if (Capacitor.getPlatform() === 'ios') {
        return Filesystem.checkPermissions()
            .then(async (result) => {
              if ((`${result.publicStorage}` === 'prompt') || (`${result.publicStorage}` === 'denied') || (`${result.publicStorage}` === 'prompt-with-rationale')) {
                return Filesystem.requestPermissions()
                    .then(async (publicStorage) => {
                      const permissionsRequested = await publicStorage.publicStorage;
                      console.log('prompt || denied || prompt-with-rationale');
                      return `${permissionsRequested}` === 'granted';
                    });
              }
              return true;
            });
      }
      return true;
    },
    async downloadFallback(doc) {
      this.loading = true;
      this.pdf = null;
      console.log('doc:', doc);
      // eslint-disable-next-line no-shadow

   //   await this.hasFilePermisions().then(result => {
        axios.get(doc, {
          responseType: 'arraybuffer',
        }).then(async (success) => {
       //   this.hasFilePermisions().then(async (resultData) => {
            //   if (resultData) {
            const arrayUrl = doc.split('/');
            const fileName = arrayUrl[arrayUrl.length - 1];
            const pdfData = await success.data;
            await this.writeAndPreviewPdf(pdfData, fileName.replace(' ', '-'));
            this.pdf = doc;
            this.title = fileName;
            console.log('doc:', doc);
            console.log('doc:', `${this.pdf}${this.localuri}`);
            await this.$router.push({
              name: 'pdf-view',
              params: { url: this.pdf, localuri: this.localuri, docType: doc.split('.').pop() },
            });
            //  }
            /*  else {
                await Dialog.alert({
                  title: 'Información',
                  message: 'Denegaste los permisos de almacenamiento y esta operación no puede ser realizada',
                });
              } */
     //     });

        });

   //   });

    },
  },
};
</script>

<style scoped>
.option-item{display:flex;align-items:center;justify-content:space-between;padding:8px 0px;
  border-bottom:1px solid #e0e0e0;transition:background-color .3s ease}
.option-item:last-child{border-bottom:none;margin-bottom: 2rem;}.selected-option{background-color:rgba(25,118,210,.1);font-weight:700;color:#7A91DB;border-radius:6px}.not-selected-option{color:#9e9e9e;opacity:.8}.option-label{display:flex;align-items:center;gap:8px}.status-badge-votations{display:inline-flex;align-items:center;gap:6px;padding:4px 10px;border-radius:20px;font-size:.9rem;font-weight:500;color:#fff;margin:4px 0}
.results-container h4{margin-bottom:2rem}
.results-container h5{margin-bottom:2rem;}
.result-item{margin-bottom:1rem;transition:opacity .3s ease}
.result-item:last-child{margin-bottom:2rem}.result-label{display:flex;justify-content:space-between;margin-bottom:.5rem;font-size:.9rem}.option-text{font-weight:500}.vote-count{color:#6c757d;font-weight:500}.progress-bar-container{width:100%;height:20px;background-color:#e9ecef;border-radius:10px;overflow:hidden}.progress-bar-fill{height:100%;border-radius:10px;transition:width .5s ease-in-out}.result-item.is-winner .option-text{font-weight:700}.result-item.is-loser{opacity:.6}
.no-vote-notice {
  text-align: center;
  margin-top: 1.5rem;
  color: #888;
  font-style: italic;
  font-size: 0.9rem;
}
</style>
